<template>
  <el-cascader
    style="width: 100%"
    ref="menuRef"
    v-model="value"
    :options="list"
    :props="props"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
export default {
  name: 'MenuSelect',
  props: {
    value: {
      required: true,
    },
    applicationInstSign: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      props: {
        label: 'resourceName',
        value: 'resourceId',
      },
    };
  },
  watch: {
    applicationInstSign() {
      this.getMenuList();
    },
  },
  mounted() {
    this.getMenuList();
  },
  methods: {
    async getMenuList() {
      if (!this.applicationInstSign) {
        return;
      }
      const res = await this.$http.get(this.$API.resource_list_post, {
        params: {
          applicationInstSign: this.applicationInstSign.split('/')[2],
        },
      });
      if (res?.data) {
        this.list = this.removeEmpty(res.data);
      }
    },
    removeEmpty(list) {
      list.forEach((v) => {
        if (v.children.length > 0) {
          v.children = this.removeEmpty(v.children);
        } else {
          delete v.children;
        }
      });
      return list;
    },
    handleChange(val) {
      const checkNodes = this.$refs.menuRef.getCheckedNodes();
      const { pathLabels, data } = checkNodes[0];
      this.$emit('input', val);
      this.$emit('update:label', pathLabels);
      this.$emit('update:info', data);
    },
  },
};
</script>
<style lang="scss" scoped>
.isCricle {
  ::v-deep .el-input__inner {
    border-radius: 16px;
  }
}
</style>
